<template lang="html">
<div class="pgInner affairEdit">

    <div class="headBar">角色管理</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
        <el-scrollbar ref="scroller" style="height:100%;">
            <div class="tabContent">
                <AddRule @inited="readyHandle" :article="param.dto" ref="AddRule" />

            </div>
        </el-scrollbar>
    </div>

    <div class="pagefoot">

        <div v-if="pgState" class="loading">
            <span v-if="pgState == 1">初始化中...</span>
            <span v-if="pgState == 2">数据保存中...</span>
            <i class="el-icon-loading"></i>
        </div>
        <div v-else>
            <el-button @click="goSave()" type="primary" size="small">保存</el-button>
            <el-button @click="goReturn" size="small">返回</el-button>
        </div>

    </div>

</div>
</template>

<script>
import {
    addArticleDTO,
    getArticleDTOById
} from '@/api/jingshi';
import {
    saveManagePostDTO,
} from '@/api/pgMent/roleMent';
import AddRule from "./src/addRule";

export default {
    components: {
        AddRule,
    },
    computed: {
        lineStr: function () {
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },
        pgState: function () {
            var state = 0;
            if (this.id && this.readyKey !== 3) {
                state = 1;
            }

            if (this.uploadIng) {
                state = 2;
            }

            return state;
        }
    },
    data() {
        return {
            id: '',
            navs: ['基本信息'],
            pageH: '',
            readyKey: 0,
            uploadIng: false,
 
            param: {
                manageEditRole: {
                    id: '',
                    name: '',
                    organizationId: '',
                    organizationIds: '',
                    organizationName: '', // 内容
                    seeRule: 1, // 摘要
                    checkRule: 1, // 标题
                    columnIds: '',
                    menuIds: '',
                }
            }
        }
    },

    methods: {
        // 保存
        save() {
            var vues = this;
            this.param.manageEditRole.class_type = "ManageEditRole";
            saveManagePostDTO(this.param).then(res => {
                console.log(res);
                this.$message.success('保存成功！');
                vues.goReturn();
            })
        },
        goSave() {
            var vues = this;
            var wait1 = this.$refs.AddRule.saveReturn();
            wait1.then(data => {
                console.log('a',data);
                if (data) {
                    for (let key in data) {
                        if (vues.param.manageEditRole.hasOwnProperty(key)) {
                            vues.param.manageEditRole[key] = data[key];
                        }
                    }
                    vues.save();
                }

            })
        },

        goReturn: function () {
            this.$router.go(-1);
        },

       
        pageFix: function () {
            this.pageH = document.documentElement.clientHeight - 205;
        },

        readyHandle: function () {
            this.readyKey++;
        },
        getDto: function () {
            var req = {
                id: this.param.dto.id,
            }
            getArticleDTOById(req).then(res => {
                this.param.dto = res.dto;
            });
        }
    },

    created: function () {
        var vues = this;
        var querys = this.$route.query;
        if (querys.id) {
            this.param.dto.id = querys.id;
            this.getDto();
        }
        console.log(vues.$refs.scroller);
        // this.prevSet();
        $(window).resize(function () {
            vues.pageFix();

            // if (vues.$refs.scroller.$data) {
            //     vues.$refs.scroller.$data.sizeHeight = this.pageH;
            // }
        })
    }
}
</script>

<style lang="scss" scoped>
.pgInner {
    background: #f5f5f5;
}

.headBar {
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    padding-left: 20px;
    background: white;
}

.tabNavs {
    height: 50px;
    padding-left: 15px;
    background: white;
    position: relative;

    .tabItem {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        margin-right: 45px;
        cursor: pointer;
    }

    .tabItem.act {
        color: rgb(86, 119, 252);
    }

    .moveLine {
        height: 2px;
        background: rgb(86, 119, 252);
        position: absolute;
        bottom: 0px;

        transition-property: all;
        transition-duration: 0.2s;
    }
}

.tabContent {
    padding: 20px;
    background: white;
}

.pagefoot {
    height: 60px;
    line-height: 60px;
    background: white;
    padding-left: 20px;
    position: relative;
    z-index: 2;

    .btn {
        height: 32px;
        padding: 0 12px;
        margin-right: 12px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
    }

    .type1 {
        line-height: 32px;
        background: rgb(86, 119, 252);
        color: white;
    }

    .type2 {
        box-sizing: border-box;
        border: 1px solid #aeaeae;
        line-height: 30px;
    }

    .loading {
        font-size: 14px;
        padding-left: 24px;
        color: #aeaeae;

        i {
            font-size: 18px;
            vertical-align: middle;
        }
    }
}
</style>

<style lang="css">
.affairEdit .pgbody {
    margin: 20px;
    background: white;
}

@media only screen and (max-width: 1366px) {
    .affairEdit .pgbody {
        margin: 10px 0;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?b26dc740